/**
 * 繁体中文
 */
export default {
  route: {
    dashboard: {
      _name: 'Dashboard',
      workplace: {_name: '工作臺'},
      analysis: {_name: '分析頁'},
      monitor: {_name: '監控頁'}
    },
    system: {
      _name: '系統管理',
      user: {
        _name: '用戶管理',
        info: {_name: ''}
      },
      role: {_name: '角色管理'},
      menu: {_name: '選單管理'},
      dictionary: {_name: '字典管理'},
      organization: {_name: '機构管理'},
      loginRecord: {_name: '登入日誌'},
      operRecord: {_name: '操作日誌'}
    },
    form: {
      _name: '表單頁面',
      basic: {_name: '基礎表單'},
      advanced: {_name: '複雜表單'},
      step: {_name: '分步表單'}
    },
    list: {
      _name: '清單頁面',
      basic: {_name: '基礎清單'},
      advanced: {_name: '複雜清單'},
      card: {
        _name: '卡片清單',
        project: {_name: '項目清單'},
        application: {_name: '應用清單'},
        article: {_name: '文章清單'}
      }
    },
    result: {
      _name: '結果頁面',
      success: {_name: '成功頁'},
      fail: {_name: '失敗頁'}
    },
    exception: {
      _name: '异常頁面',
      '403': {_name: '403'},
      '404': {_name: '404'},
      '500': {_name: '500'}
    },
    user: {
      _name: '個人中心',
      profile: {_name: '個人資料'},
      message: {_name: '我的消息'}
    },
    extension: {
      _name: '擴展組件',
      icon: {_name: '字體圖標'},
      file: {_name: '檔案清單'},
      printer: {_name: '列印挿件'},
      excel: {_name: 'excel挿件'},
      dragsort: {_name: '拖拽排序'},
      map: {_name: '地圖組件'},
      player: {_name: '視頻播放'},
      editor: {_name: '富文本框'},
      more: {_name: '更多組件'}
    },
    example: {
      _name: '經典實例',
      document: {_name: '案卷調整'},
      choose: {_name: '批量選擇'},
    },
    'http://www.xxx.com': {_name: '獲取授權'}
  },
  layout: {
    home: '主頁',
    header: {
      profile: '個人中心',
      password: '修改密碼',
      logout: '安全登出'
    },
    footer: {
      website: '官網',
      document: '檔案',
      authorization: '授權',
      copyright: 'Copyright © 2021 南京RXThinkCMF研發中心'
    },
    logout: {
      title: '詢問',
      message: '確定要登出嗎?'
    }
  },
  login: {
    title: 'XXX - 管理後台',
    username: '請輸入登入帳號',
    password: '請輸入登入密碼',
    captcha: '請輸入驗證碼',
    remember: '記住密碼',
    forget: '忘記密碼',
    login: '登入',
    loading: '登入中'
  },





    // 通用
    universal:{
      startingtime:"開始時間",
      endtime:"結束時間",
      pleasechoose:"請選擇",
      pleaseenter:"請輸入",
      recognize: "確認",
      inquire:"查詢",
      reset:"重置",
      export:"導出",
      turnon:"開啓",
      closure:"關閉",
      yes:"是",
      no:"否",
      unknown: '未知',
      success: '成功',
      retreat: '撤銷',
      abnormal: '異常',
      cancel: '取消',
    },
    // 首页
    home:{
      totalbalance:"总余额",
      availablebalance:"可用余额",
      freezebalance:"冻结金额",
      unsettledamount:"未结算余额",
    },
    // 清理数据
    cleandata:{
      selecttime:"選擇時間",
      startingtime:"開始時間",
      endtime:"結束時間",
      selectdata:"選擇數據",
      choose:"請選擇",
      option1:"[ 全部數據 ] | 謹慎選擇，刪除后無法恢復!!!",
      option2:"[ 收款數據 ] | 謹慎選擇，刪除后無法恢復!!!",
      option3:"[ 出款數據 ] | 謹慎選擇，刪除后無法恢復!!!",
      option4:"[ 賬變數據 ] | 謹慎選擇，刪除后無法恢復!!!",
      warnings: "提示：請謹慎刪除，操作后無法恢復！",
      recognize: "确认"
    },
    // 订单列表
    orderlist:{
      username:"用戶名稱",
      userorder:"用戶訂單",
      systemorder:"系統訂單",
      transactiontype:"交易類型",
      channelorder:"通道訂單",
      tradingstatus:"交易狀態",
      transactionaccountchanges:"交易賬變",
      selectionperiod:"選擇時間",
    },
    // 头部统计
    statistics:{
      today_success:"[今日成功]:",
      today_receipt:"[今日收款]:",
      unknown_orders:" [未知訂單]:",
      unknown_amount:" [未知金額]:",
      service_fee:" [交易手續費]:",
      order_rate:" [訂單費率]:",
    }
}
